import { RootState } from '../store';

export const maintenanceSelector = (state: RootState) => ({
  isMaintenanceLoading: state.maintenance.isMaintenanceLoading,
  maintenanceMode: state.maintenance.maintenanceMode,
});
